export default function BrevetLevelASubthemeNameText({text}) {
    // Used in

    // BUILD
    return (
        <span className={"font-normal text-[14px] text-greyLight7"}>
            {text}
        </span>
    );
}